/* eslint-disable */

export enum IdentifierType {
  /** IDENTIFIER_TYPE_UNKNOWN - Used when the calling service is unsure of the type of the identifier token provided */
  IDENTIFIER_TYPE_UNKNOWN = "IDENTIFIER_TYPE_UNKNOWN",
  /** IDENTIFIER_TYPE_BUSINESS_PROFILE - Business identifier - business profile, token starting with BP_ */
  IDENTIFIER_TYPE_BUSINESS_PROFILE = "IDENTIFIER_TYPE_BUSINESS_PROFILE",
  /** IDENTIFIER_TYPE_BUSINESS_MERCHANTEIN_PARENT - Business identifier - merchantein parent, token starting with M_ */
  IDENTIFIER_TYPE_BUSINESS_MERCHANTEIN_PARENT = "IDENTIFIER_TYPE_BUSINESS_MERCHANTEIN_PARENT",
  /** IDENTIFIER_TYPE_BUSINESS_CASH_APP_PAY - Business identifier - Cash App Pay (merbro merchant), token starting with MMI_ */
  IDENTIFIER_TYPE_BUSINESS_CASH_APP_PAY = "IDENTIFIER_TYPE_BUSINESS_CASH_APP_PAY",
  /** IDENTIFIER_TYPE_OFFER_OFFERLY - Offer identifier - offerly, token starting with OF_ */
  IDENTIFIER_TYPE_OFFER_OFFERLY = "IDENTIFIER_TYPE_OFFER_OFFERLY",
  /** IDENTIFIER_TYPE_OFFER_BOOST - Offer identifier - Boost (rewardly), token starting with CR_ */
  IDENTIFIER_TYPE_OFFER_BOOST = "IDENTIFIER_TYPE_OFFER_BOOST",
}

/** Reference to an entity represented within cash-storefronts */
export interface Identifier {
  type?: IdentifierType;
  token?: string;
}
